import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Dibrugarh';
  ngOnInit(): void {
    const progressBar = document.querySelector('#progressBar');
    window.addEventListener('visibility', (event) => {
      if (event.bubbles) {
        progressBar.classList.add('active');
      } else {
        progressBar.classList.remove('active');
      }
    });
  }
}
